import { useState } from "react";
import { InputSwitch } from "primereact/inputswitch";
import { toast } from "react-toastify";
import Input from "../../../../componentes/input/input";
import Textarea from "../../../../componentes/input/textarea";
import DateMasked from "../../../../componentes/inputMask/DateMasked";
import Button from "../../../../componentes/button/button";
import AcaoButtons from "../../Shared/AcaoButtons";
import CadastroClienteService from "../../../../services/resource/cadastroClienteService";
import InputFormat from "../../../../componentes/inputMask/inputMask";

const service = new CadastroClienteService();

// Campo Sim/Não como toggle — mais rápido de preencher que um dropdown de 2 opções. Campos ainda
// sem resposta (null, vindos de um rascunho salvo antes desta mudança) começam desligados (Não).
function CampoToggle({ label, value, onChange }) {
    return (
        <div className="flex flex-col gap-1.5">
            <span className="text-sm font-medium text-foreground/80">{label}</span>
            <div className="h-9 flex items-center gap-2">
                <InputSwitch checked={!!value} onChange={e => onChange(e.value)} />
                <span className="text-sm text-muted-foreground">{value ? "Sim" : "Não"}</span>
            </div>
        </div>
    );
}

function formInicial(detalheProcesso) {
    return {
        observacoesFinanceiro: detalheProcesso?.observacoesFinanceiro ?? "",
        documentacaoCompleta: detalheProcesso?.documentacaoCompleta ?? null,
        jaPossuiCadastro: detalheProcesso?.jaPossuiCadastro ?? null,
        coordenadasCadastradas: detalheProcesso?.coordenadasCadastradas ?? null,
        registroLigacao: detalheProcesso?.registroLigacao ?? "",
        novoCodigoCliente: detalheProcesso?.novoCodigoCliente ?? "",
        confirmacaoDados: detalheProcesso?.confirmacaoDados ?? null,
        consultadoBoaVista: detalheProcesso?.consultadoBoaVista ?? null,
        consultadoConfirme: detalheProcesso?.consultadoConfirme ?? null,
        consultadoReceita: detalheProcesso?.consultadoReceita ?? null,
    };
}

// Etapa "Informações Financeiras" — o Financeiro complementa/valida o cadastro e aprova a conclusão.
export default function EtapaCadastroClienteFinanceiro({ solicitacao, detalheProcesso, acoes = [], acaoEmExecucao, onExecutarAcao, onDepoisDeAgir }) {
    const [form, setForm] = useState(() => formInicial(detalheProcesso));
    const [salvandoRascunho, setSalvandoRascunho] = useState(false);

    function set(campo, valor) {
        setForm(prev => ({ ...prev, [campo]: valor }));
    }

    function executar(acao) {
        onExecutarAcao(acao, { dados: form });
    }

    function salvarRascunho() {
        setSalvandoRascunho(true);
        service.salvarRascunhoFinanceiro(solicitacao.id, form)
            .then(() => {
                toast.success("Rascunho salvo.");
                onDepoisDeAgir?.();
            })
            .catch(error => console.error("Erro ao salvar rascunho das informações financeiras", error))
            .finally(() => setSalvandoRascunho(false));
    }

    return (
        <div className="flex flex-col gap-4">
            <p className="text-sm text-muted-foreground">
                Revise as informações do cadastro e conclua o processo. Informe observações se necessário.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <CampoToggle label="Documentação completa" value={form.documentacaoCompleta} onChange={v => set("documentacaoCompleta", v)} />
                <CampoToggle label="Já possui cadastro?" value={form.jaPossuiCadastro} onChange={v => set("jaPossuiCadastro", v)} />
                <CampoToggle label="Coordenadas cadastradas" value={form.coordenadasCadastradas} onChange={v => set("coordenadasCadastradas", v)} />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <DateMasked type="date" label="Registro de Ligação" value={form.registroLigacao} onChange={v => set("registroLigacao", v)} />
                <InputFormat
                    label="Novo Código Cliente"
                    required
                    mask="9999-9999"
                    value={form.novoCodigoCliente}
                    onChange={e => set("novoCodigoCliente", e)}
                    placeholder="0000-0000"
                />
                <CampoToggle label="Confirmação dados" value={form.confirmacaoDados} onChange={v => set("confirmacaoDados", v)} />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <CampoToggle label="Consultado no Boa Vista" value={form.consultadoBoaVista} onChange={v => set("consultadoBoaVista", v)} />
                <CampoToggle label="Consultado no Confirme" value={form.consultadoConfirme} onChange={v => set("consultadoConfirme", v)} />
                <CampoToggle label="Consultado na Receita" value={form.consultadoReceita} onChange={v => set("consultadoReceita", v)} />
            </div>

            <Textarea
                label="Observações do Financeiro"
                value={form.observacoesFinanceiro}
                onChange={e => set("observacoesFinanceiro", e.target.value)}
                rows={3}
            />
            <div className="flex flex-wrap gap-2 justify-end">
                <Button variant="outline" label="Salvar rascunho" iconLeft="fa fa-save" loading={salvandoRascunho} disabled={!!acaoEmExecucao} onClick={salvarRascunho} />
                <AcaoButtons acoes={acoes} acaoEmExecucao={acaoEmExecucao} onAcao={executar} disabled={salvandoRascunho} />
            </div>
        </div>
    );
}
